import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';

import { SIDE_DRAWER_DIALOG_CLASS } from '~/components/MFEProvider/lib/MUI/themes/v2/components/Dialog';

import { SideDrawerProps } from '..';
import SideDrawerContent from './SideDrawerContent';
import SideDrawerFooter from './SideDrawerFooter';
import SideDrawerHeader from './SideDrawerHeader';

const DIALOG_WIDTH = '640px';

const DialogView: React.FC<SideDrawerProps> = ({
  open,
  onClose,
  onSave,
  title,
  children = undefined,
  isError = false,
  isLoading = false,
  buttonLabel = '',
  primaryDisabled = false,
  primaryTestId = '',
  primaryActionColor = 'primary',
  sideDrawerTestId = 'side-drawer',
  cancelTestId = 'cancel-button',
  loaderRows = 3,
  headerActions = null,
  isCancelButtonPrimary = false,
}) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  const footerPrimaryAction = onSave
    ? {
        label: buttonLabel || t('common:actions.continue'),
        onClick: onSave,
        loading: isLoading,
        disabled: primaryDisabled,
        dataTestId: primaryTestId,
        color: primaryActionColor,
      }
    : undefined;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={SIDE_DRAWER_DIALOG_CLASS}
      data-testid={sideDrawerTestId}
      PaperProps={{
        sx: {
          width: DIALOG_WIDTH,
          maxWidth: DIALOG_WIDTH,
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          justifyContent: 'space-between',
        },
      }}
    >
      <DialogContent
        sx={{
          padding: theme.spacing(4),
          pb: 0,
          display: 'flex',
          justifyContent: 'center',
          overflowX: 'hidden',
        }}
      >
        <Box>
          <SideDrawerHeader
            title={title}
            onClose={onClose}
            actions={headerActions}
          />

          <SideDrawerContent isError={isError} loaderRows={loaderRows}>
            {children}
          </SideDrawerContent>
        </Box>
      </DialogContent>

      <SideDrawerFooter
        onCancel={onClose}
        cancelTestId={cancelTestId}
        footerPrimaryAction={footerPrimaryAction}
        isCancelButtonPrimary={isCancelButtonPrimary}
      />
    </Dialog>
  );
};

export default DialogView;
